import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonResponsibilityResponse } from '@/api/services/common/responsibility/common-responsibility.dto'
import { WorkPhaseResponse } from '@/modules/configurationModule/detail/incidents/incidents-origins/models/incidents-origins.dto'
import { IncidentOriginResponse } from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.dto'
import { IncidentSeverityResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.dto'
import { IncidentTypeResponse } from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.dto'
import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisContentScrollTable, StatisticalAnalysisIncidentsTimesTypeSelectorEnum, StatisticalAnalysisIncidentTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisIncidentsStatisticsDossierGroupingColumnEnum {
    INCIDENT_ORIGIN = 'INCIDENT_ORIGIN',
    INCIDENT_TYPE = 'INCIDENT_TYPE',
    INCIDENT_SEVERITY = 'INCIDENT_SEVERITY',
    CORE_ENTITY = 'CORE_ENTITY',
    OPENED_BY = 'OPENED_BY',
    CLOSED_BY = 'CLOSED_BY',
    PHASE = 'PHASE',
    IS_OPEN = 'IS_OPEN'
}

export enum StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum {
    INCIDENT_ORIGIN = 'INCIDENT_ORIGIN',
    INCIDENT_TYPE = 'INCIDENT_TYPE',
    INCIDENT_SEVERITY = 'INCIDENT_SEVERITY',
    CORE_ENTITY = 'CORE_ENTITY',
    OPENED_BY = 'OPENED_BY',
    CLOSED_BY = 'CLOSED_BY',
    PHASE = 'PHASE'
}
export interface StatisticalAnalysisIncidentStatisticsDossierCaseVirtualState {
    state: StatisticalAnalysisIncidentTypes
    total: number
}
export interface StatisticalAnalysisIncidentStatisticsDossierCase {
    total:number
    totalByState: StatisticalAnalysisIncidentStatisticsDossierCaseVirtualState[]
}

export interface StatisticalAnalysisIncidentsStatisticsDossierBaseRequest {
    startDate: string,
    endDate: string,
    laboratoryIds: number[],
    laboratoryUserId: number
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailRequest {
    groupByFields: string[]
    infoDetail: StatisticalAnalysisTemporalFilterEnum,
    infoType: StatisticalAnalysisIncidentsTimesTypeSelectorEnum,
}

export interface StatisticalAnalysisIncidentsStatisticsDossierGroupRequest {
    groupBy1: StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum
    groupBy2: StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailViewChartResponseInternalGroups {
    name: string
    count: number
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailViewChart {
    groupBy1: string
    groupBy2: StatisticalAnalysisIncidentsStatisticsDossierDetailViewChartResponseInternalGroups[]
}

export interface StatisticalAnalysisIncidentsStatisticsDossierGeneralStatistics {
    max: number
    mean: number
    median: number
    min: number
    variation: number
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableCoreEntity {
    code: string
    translatedName: string
}

export interface StatisticalAnalysisIncidentsStatisticsDossierStats {
    deviation: number
    maxTime: number
    mean: number
    median: number
    minTime: number
    percent: number
    totalIncidents: number
}
export interface StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent {
    closedBy: StatisticalAnalysisViewDetailTableGroupingColumns
    coreEntity: StatisticalAnalysisViewDetailTableGroupingColumns
    incidentOrigin: StatisticalAnalysisViewDetailTableGroupingColumns
    incidentSeverity: StatisticalAnalysisViewDetailTableGroupingColumns
    incidentType: StatisticalAnalysisViewDetailTableGroupingColumns
    isOpen: StatisticalAnalysisViewDetailTableGroupingColumns
    openedBy: StatisticalAnalysisViewDetailTableGroupingColumns
    phase: StatisticalAnalysisViewDetailTableGroupingColumns
    stats: StatisticalAnalysisIncidentsStatisticsDossierStats
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent {
    closedBy: CommonPersonnelResponse
    closingDate: string
    coreEntity: StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableCoreEntity
    entityExternalId: string
    incidentId: number
    incidentDate: string
    incidentLabel: string
    incidentOrigin: IncidentOriginResponse
    incidentSeverity: IncidentSeverityResponse
    incidentType: IncidentTypeResponse
    laboratory: CommonLaboratoryResponse
    notifiedPersonnel: CommonPersonnelResponse
    notifiedResponsabilities: CommonResponsibilityResponse
    openedBy: CommonPersonnelResponse
    openingDate: string
    phase: WorkPhaseResponse
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailViewTable {
    content: StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTable {
    content: StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent[]
    scrollPage: StatisticalAnalysisContentScrollTable
}
